export default __webpack_public_path__ + "static/media/3.986c2d95.jpg";